// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DHL5B2GSvT0RC5k9VHsrv","innerWrapper":"wgvyPZ2ykNy55GwzNVUpQ"};